
<div class="footer-container"[style]="styleExpression" >
  <h1>POWERED BY</h1>
  <a href="https://www.gbarena.com" target="_blank" class="gbarena">
    <img src="assets/img/GBarena-type.svg" style="width: 70px" alt="GBarena Logo">
  </a>
</div>
